export const countries = [
    { label: 'Afghanistan', value: 'AF' },
    { label: 'Åland Islands', value: 'AX' },
    { label: 'Albania', value: 'AL' },
    { label: 'Algeria', value: 'DZ' },
    { label: 'American Samoa', value: 'AS' },
    { label: 'AndorrA', value: 'AD' },
    { label: 'Angola', value: 'AO' },
    { label: 'Anguilla', value: 'AI' },
    { label: 'Antarctica', value: 'AQ' },
    { label: 'Antigua and Barbuda', value: 'AG' },
    { label: 'Argentina', value: 'AR' },
    { label: 'Armenia', value: 'AM' },
    { label: 'Aruba', value: 'AW' },
    { label: 'Australia', value: 'AU' },
    { label: 'Austria', value: 'AT' },
    { label: 'Azerbaijan', value: 'AZ' },
    { label: 'Bahamas', value: 'BS' },
    { label: 'Bahrain', value: 'BH' },
    { label: 'Bangladesh', value: 'BD' },
    { label: 'Barbados', value: 'BB' },
    { label: 'Belarus', value: 'BY' },
    { label: 'Belgium', value: 'BE' },
    { label: 'Belize', value: 'BZ' },
    { label: 'Benin', value: 'BJ' },
    { label: 'Bermuda', value: 'BM' },
    { label: 'Bhutan', value: 'BT' },
    { label: 'Bolivia', value: 'BO' },
    { label: 'Bosnia and Herzegovina', value: 'BA' },
    { label: 'Botswana', value: 'BW' },
    { label: 'Bouvet Island', value: 'BV' },
    { label: 'Brazil', value: 'BR' },
    { label: 'British Indian Ocean Territory', value: 'IO' },
    { label: 'Brunei Darussalam', value: 'BN' },
    { label: 'Bulgaria', value: 'BG' },
    { label: 'Burkina Faso', value: 'BF' },
    { label: 'Burundi', value: 'BI' },
    { label: 'Cambodia', value: 'KH' },
    { label: 'Cameroon', value: 'CM' },
    { label: 'Canada', value: 'CA' },
    { label: 'Cape Verde', value: 'CV' },
    { label: 'Cayman Islands', value: 'KY' },
    { label: 'Central African Republic', value: 'CF' },
    { label: 'Chad', value: 'TD' },
    { label: 'Chile', value: 'CL' },
    { label: 'China', value: 'CN' },
    { label: 'Christmas Island', value: 'CX' },
    { label: 'Cocos (Keeling) Islands', value: 'CC' },
    { label: 'Colombia', value: 'CO' },
    { label: 'Comoros', value: 'KM' },
    { label: 'Congo', value: 'CG' },
    { label: 'Congo, The Democratic Republic of the', value: 'CD' },
    { label: 'Cook Islands', value: 'CK' },
    { label: 'Costa Rica', value: 'CR' },
    { label: 'Cote D\'Ivoire', value: 'CI' },
    { label: 'Croatia', value: 'HR' },
    { label: 'Cuba', value: 'CU' },
    { label: 'Cyprus', value: 'CY' },
    { label: 'Czech Republic', value: 'CZ' },
    { label: 'Denmark', value: 'DK' },
    { label: 'Djibouti', value: 'DJ' },
    { label: 'Dominica', value: 'DM' },
    { label: 'Dominican Republic', value: 'DO' },
    { label: 'Ecuador', value: 'EC' },
    { label: 'Egypt', value: 'EG' },
    { label: 'El Salvador', value: 'SV' },
    { label: 'Equatorial Guinea', value: 'GQ' },
    { label: 'Eritrea', value: 'ER' },
    { label: 'Estonia', value: 'EE' },
    { label: 'Ethiopia', value: 'ET' },
    { label: 'Falkland Islands (Malvinas)', value: 'FK' },
    { label: 'Faroe Islands', value: 'FO' },
    { label: 'Fiji', value: 'FJ' },
    { label: 'Finland', value: 'FI' },
    { label: 'France', value: 'FR' },
    { label: 'French Guiana', value: 'GF' },
    { label: 'French Polynesia', value: 'PF' },
    { label: 'French Southern Territories', value: 'TF' },
    { label: 'Gabon', value: 'GA' },
    { label: 'Gambia', value: 'GM' },
    { label: 'Georgia', value: 'GE' },
    { label: 'Germany', value: 'DE' },
    { label: 'Ghana', value: 'GH' },
    { label: 'Gibraltar', value: 'GI' },
    { label: 'Greece', value: 'GR' },
    { label: 'Greenland', value: 'GL' },
    { label: 'Grenada', value: 'GD' },
    { label: 'Guadeloupe', value: 'GP' },
    { label: 'Guam', value: 'GU' },
    { label: 'Guatemala', value: 'GT' },
    { label: 'Guernsey', value: 'GG' },
    { label: 'Guinea', value: 'GN' },
    { label: 'Guinea-Bissau', value: 'GW' },
    { label: 'Guyana', value: 'GY' },
    { label: 'Haiti', value: 'HT' },
    { label: 'Heard Island and Mcdonald Islands', value: 'HM' },
    { label: 'Holy See (Vatican City State)', value: 'VA' },
    { label: 'Honduras', value: 'HN' },
    { label: 'Hong Kong', value: 'HK' },
    { label: 'Hungary', value: 'HU' },
    { label: 'Iceland', value: 'IS' },
    { label: 'India', value: 'IN' },
    { label: 'Indonesia', value: 'ID' },
    { label: 'Iran, Islamic Republic Of', value: 'IR' },
    { label: 'Iraq', value: 'IQ' },
    { label: 'Ireland', value: 'IE' },
    { label: 'Isle of Man', value: 'IM' },
    { label: 'Israel', value: 'IL' },
    { label: 'Italy', value: 'IT' },
    { label: 'Jamaica', value: 'JM' },
    { label: 'Japan', value: 'JP' },
    { label: 'Jersey', value: 'JE' },
    { label: 'Jordan', value: 'JO' },
    { label: 'Kazakhstan', value: 'KZ' },
    { label: 'Kenya', value: 'KE' },
    { label: 'Kiribati', value: 'KI' },
    { label: 'Korea, Democratic People\'S Republic of', value: 'KP' },
    { label: 'Korea, Republic of', value: 'KR' },
    { label: 'Kuwait', value: 'KW' },
    { label: 'Kyrgyzstan', value: 'KG' },
    { label: 'Lao People\'S Democratic Republic', value: 'LA' },
    { label: 'Latvia', value: 'LV' },
    { label: 'Lebanon', value: 'LB' },
    { label: 'Lesotho', value: 'LS' },
    { label: 'Liberia', value: 'LR' },
    { label: 'Libyan Arab Jamahiriya', value: 'LY' },
    { label: 'Liechtenstein', value: 'LI' },
    { label: 'Lithuania', value: 'LT' },
    { label: 'Luxembourg', value: 'LU' },
    { label: 'Macao', value: 'MO' },
    { label: 'Macedonia, The Former Yugoslav Republic of', value: 'MK' },
    { label: 'Madagascar', value: 'MG' },
    { label: 'Malawi', value: 'MW' },
    { label: 'Malaysia', value: 'MY' },
    { label: 'Maldives', value: 'MV' },
    { label: 'Mali', value: 'ML' },
    { label: 'Malta', value: 'MT' },
    { label: 'Marshall Islands', value: 'MH' },
    { label: 'Martinique', value: 'MQ' },
    { label: 'Mauritania', value: 'MR' },
    { label: 'Mauritius', value: 'MU' },
    { label: 'Mayotte', value: 'YT' },
    { label: 'Mexico', value: 'MX' },
    { label: 'Micronesia, Federated States of', value: 'FM' },
    { label: 'Moldova, Republic of', value: 'MD' },
    { label: 'Monaco', value: 'MC' },
    { label: 'Mongolia', value: 'MN' },
    { label: 'Montserrat', value: 'MS' },
    { label: 'Morocco', value: 'MA' },
    { label: 'Mozambique', value: 'MZ' },
    { label: 'Myanmar', value: 'MM' },
    { label: 'Namibia', value: 'NA' },
    { label: 'Nauru', value: 'NR' },
    { label: 'Nepal', value: 'NP' },
    { label: 'Netherlands', value: 'NL' },
    { label: 'Netherlands Antilles', value: 'AN' },
    { label: 'New Caledonia', value: 'NC' },
    { label: 'New Zealand', value: 'NZ' },
    { label: 'Nicaragua', value: 'NI' },
    { label: 'Niger', value: 'NE' },
    { label: 'Nigeria', value: 'NG' },
    { label: 'Niue', value: 'NU' },
    { label: 'Norfolk Island', value: 'NF' },
    { label: 'Northern Mariana Islands', value: 'MP' },
    { label: 'Norway', value: 'NO' },
    { label: 'Oman', value: 'OM' },
    { label: 'Pakistan', value: 'PK' },
    { label: 'Palau', value: 'PW' },
    { label: 'Palestinian Territory, Occupied', value: 'PS' },
    { label: 'Panama', value: 'PA' },
    { label: 'Papua New Guinea', value: 'PG' },
    { label: 'Paraguay', value: 'PY' },
    { label: 'Peru', value: 'PE' },
    { label: 'Philippines', value: 'PH' },
    { label: 'Pitcairn', value: 'PN' },
    { label: 'Poland', value: 'PL' },
    { label: 'Portugal', value: 'PT' },
    { label: 'Puerto Rico', value: 'PR' },
    { label: 'Qatar', value: 'QA' },
    { label: 'Reunion', value: 'RE' },
    { label: 'Romania', value: 'RO' },
    { label: 'Russian Federation', value: 'RU' },
    { label: 'RWANDA', value: 'RW' },
    { label: 'Saint Helena', value: 'SH' },
    { label: 'Saint Kitts and Nevis', value: 'KN' },
    { label: 'Saint Lucia', value: 'LC' },
    { label: 'Saint Pierre and Miquelon', value: 'PM' },
    { label: 'Saint Vincent and the Grenadines', value: 'VC' },
    { label: 'Samoa', value: 'WS' },
    { label: 'San Marino', value: 'SM' },
    { label: 'Sao Tome and Principe', value: 'ST' },
    { label: 'Saudi Arabia', value: 'SA' },
    { label: 'Senegal', value: 'SN' },
    { label: 'Serbia and Montenegro', value: 'CS' },
    { label: 'Seychelles', value: 'SC' },
    { label: 'Sierra Leone', value: 'SL' },
    { label: 'Singapore', value: 'SG' },
    { label: 'Slovakia', value: 'SK' },
    { label: 'Slovenia', value: 'SI' },
    { label: 'Solomon Islands', value: 'SB' },
    { label: 'Somalia', value: 'SO' },
    { label: 'South Africa', value: 'ZA' },
    { label: 'South Georgia and the South Sandwich Islands', value: 'GS' },
    { label: 'Spain', value: 'ES' },
    { label: 'Sri Lanka', value: 'LK' },
    { label: 'Sudan', value: 'SD' },
    { label: 'Surilabel', value: 'SR' },
    { label: 'Svalbard and Jan Mayen', value: 'SJ' },
    { label: 'Swaziland', value: 'SZ' },
    { label: 'Sweden', value: 'SE' },
    { label: 'Switzerland', value: 'CH' },
    { label: 'Syrian Arab Republic', value: 'SY' },
    { label: 'Taiwan, Province of China', value: 'TW' },
    { label: 'Tajikistan', value: 'TJ' },
    { label: 'Tanzania, United Republic of', value: 'TZ' },
    { label: 'Thailand', value: 'TH' },
    { label: 'Timor-Leste', value: 'TL' },
    { label: 'Togo', value: 'TG' },
    { label: 'Tokelau', value: 'TK' },
    { label: 'Tonga', value: 'TO' },
    { label: 'Trinidad and Tobago', value: 'TT' },
    { label: 'Tunisia', value: 'TN' },
    { label: 'Turkey', value: 'TR' },
    { label: 'Turkmenistan', value: 'TM' },
    { label: 'Turks and Caicos Islands', value: 'TC' },
    { label: 'Tuvalu', value: 'TV' },
    { label: 'Uganda', value: 'UG' },
    { label: 'Ukraine', value: 'UA' },
    { label: 'United Arab Emirates', value: 'AE' },
    { label: 'United Kingdom', value: 'GB' },
    { label: 'United States', value: 'US' },
    { label: 'United States Minor Outlying Islands', value: 'UM' },
    { label: 'Uruguay', value: 'UY' },
    { label: 'Uzbekistan', value: 'UZ' },
    { label: 'Vanuatu', value: 'VU' },
    { label: 'Venezuela', value: 'VE' },
    { label: 'Viet Nam', value: 'VN' },
    { label: 'Virgin Islands, British', value: 'VG' },
    { label: 'Virgin Islands, U.S.', value: 'VI' },
    { label: 'Wallis and Futuna', value: 'WF' },
    { label: 'Western Sahara', value: 'EH' },
    { label: 'Yemen', value: 'YE' },
    { label: 'Zambia', value: 'ZM' },
    { label: 'Zimbabwe', value: 'ZW' }
]
export const dma = [
    {
        label: "Portland-Auburn",
        value: "500"
    },
    {
        label: "New York",
        value: "501"
    },
    {
        label: "Binghamton",
        value: "502"
    },
    {
        label: "Macon",
        value: "503"
    },
    {
        label: "Philadelphia",
        value: "504"
    },
    {
        label: "Detroit",
        value: "505"
    },
    {
        label: "Boston (Manchester)",
        value: "506"
    },
    {
        label: "Savannah",
        value: "507"
    },
    {
        label: "Pittsburgh",
        value: "508"
    },
    {
        label: "Ft. Wayne",
        value: "509"
    },
    {
        label: "Cleveland-Akron (Canton)",
        value: "510"
    },
    {
        label: "Washington, DC (Hagrstwn)",
        value: "511"
    },
    {
        label: "Baltimore",
        value: "512"
    },
    {
        label: "Flint-Saginaw-Bay City",
        value: "513"
    },
    {
        label: "Buffalo",
        value: "514"
    },
    {
        label: "Cincinnati",
        value: "515"
    },
    {
        label: "Erie",
        value: "516"
    },
    {
        label: "Charlotte",
        value: "517"
    },
    {
        label: "Greensboro-H.Point-W.Salem",
        value: "518"
    },
    {
        label: "Charleston, SC",
        value: "519"
    },
    {
        label: "Augusta-Aiken",
        value: "520"
    },
    {
        label: "Providence-New Bedford",
        value: "521"
    },
    {
        label: "Columbus, GA (Opelika, AL)",
        value: "522"
    },
    {
        label: "Burlington-Plattsburgh",
        value: "523"
    },
    {
        label: "Atlanta",
        value: "524"
    },
    {
        label: "Albany, GA",
        value: "525"
    },
    {
        label: "Utica",
        value: "526"
    },
    {
        label: "Indianapolis",
        value: "527"
    },
    {
        label: "Miami-Ft. Lauderdale",
        value: "528"
    },
    {
        label: "Louisville",
        value: "529"
    },
    {
        label: "Tallahassee-Thomasville",
        value: "530"
    },
    {
        label: "Tri-Cities, TN-VA",
        value: "531"
    },
    {
        label: "Albany-Schenectady-Troy",
        value: "532"
    },
    {
        label: "Hartford & New Haven",
        value: "533"
    },
    {
        label: "Orlando-Daytona Bch-Melbrn",
        value: "534"
    },
    {
        label: "Columbus, OH",
        value: "535"
    },
    {
        label: "Youngstown",
        value: "536"
    },
    {
        label: "Bangor",
        value: "537"
    },
    {
        label: "Rochester, NY",
        value: "538"
    },
    {
        label: "Tampa-St. Pete (Sarasota)",
        value: "539"
    },
    {
        label: "Traverse City-Cadillac",
        value: "540"
    },
    {
        label: "Lexington",
        value: "541"
    },
    {
        label: "Dayton",
        value: "542"
    },
    {
        label: "Springfield-Holyoke",
        value: "543"
    },
    {
        label: "Norfolk-Portsmth-Newpt Nws",
        value: "544"
    },
    {
        label: "Greenville-N.Bern-Washngtn",
        value: "545"
    },
    {
        label: "Columbia, SC",
        value: "546"
    },
    {
        label: "Toledo",
        value: "547"
    },
    {
        label: "West Palm Beach-Ft. Pierce",
        value: "548"
    },
    {
        label: "Watertown",
        value: "549"
    },
    {
        label: "Wilmington",
        value: "550"
    },
    {
        label: "Lansing",
        value: "551"
    },
    {
        label: "Presque Isle",
        value: "552"
    },
    {
        label: "Marquette",
        value: "553"
    },
    {
        label: "Wheeling-Steubenville",
        value: "554"
    },
    {
        label: "Syracuse",
        value: "555"
    },
    {
        label: "Richmond-Petersburg",
        value: "556"
    },
    {
        label: "Knoxville",
        value: "557"
    },
    {
        label: "Lima",
        value: "558"
    },
    {
        label: "Bluefield-Beckley-Oak Hill",
        value: "559"
    },
    {
        label: "Raleigh-Durham (Fayetvlle)",
        value: "560"
    },
    {
        label: "Jacksonville",
        value: "561"
    },
    {
        label: "Grand Rapids-Kalmzoo-B.Crk",
        value: "563"
    },
    {
        label: "Charleston-Huntington",
        value: "564"
    },
    {
        label: "Elmira (Corning)",
        value: "565"
    },
    {
        label: "Harrisburg-Lncstr-Leb-York",
        value: "566"
    },
    {
        label: "Greenvll-Spart-Ashevll-And",
        value: "567"
    },
    {
        label: "Harrisonburg",
        value: "569"
    },
    {
        label: "Myrtle Beach-Florence",
        value: "570"
    },
    {
        label: "Ft. Myers-Naples",
        value: "571"
    },
    {
        label: "Roanoke-Lynchburg",
        value: "573"
    },
    {
        label: "Johnstown-Altoona-St Colge",
        value: "574"
    },
    {
        label: "Chattanooga",
        value: "575"
    },
    {
        label: "Salisbury",
        value: "576"
    },
    {
        label: "Wilkes Barre-Scranton-Hztn",
        value: "577"
    },
    {
        label: "Terre Haute",
        value: "581"
    },
    {
        label: "Lafayette, IN",
        value: "582"
    },
    {
        label: "Alpena",
        value: "583"
    },
    {
        label: "Charlottesville",
        value: "584"
    },
    {
        label: "South Bend-Elkhart",
        value: "588"
    },
    {
        label: "Gainesville",
        value: "592"
    },
    {
        label: "Zanesville",
        value: "596"
    },
    {
        label: "Parkersburg",
        value: "597"
    },
    {
        label: "Clarksburg-Weston",
        value: "598"
    },
    {
        label: "Corpus Christi",
        value: "600"
    },
    {
        label: "Chicago",
        value: "602"
    },
    {
        label: "Joplin-Pittsburg",
        value: "603"
    },
    {
        label: "Columbia-Jefferson City",
        value: "604"
    },
    {
        label: "Topeka",
        value: "605"
    },
    {
        label: "Dothan",
        value: "606"
    },
    {
        label: "St. Louis",
        value: "609"
    },
    {
        label: "Rockford",
        value: "610"
    },
    {
        label: "Rochestr-Mason City-Austin",
        value: "611"
    },
    {
        label: "Shreveport",
        value: "612"
    },
    {
        label: "Minneapolis-St. Paul",
        value: "613"
    },
    {
        label: "Kansas City",
        value: "616"
    },
    {
        label: "Milwaukee",
        value: "617"
    },
    {
        label: "Houston",
        value: "618"
    },
    {
        label: "Springfield, MO",
        value: "619"
    },
    {
        label: "New Orleans",
        value: "622"
    },
    {
        label: "Dallas-Ft. Worth",
        value: "623"
    },
    {
        label: "Sioux City",
        value: "624"
    },
    {
        label: "Waco-Temple-Bryan",
        value: "625"
    },
    {
        label: "Victoria",
        value: "626"
    },
    {
        label: "Wichita Falls & Lawton",
        value: "627"
    },
    {
        label: "Monroe-El Dorado",
        value: "628"
    },
    {
        label: "Birmingham (Ann and Tusc)",
        value: "630"
    },
    {
        label: "Ottumwa-Kirksville",
        value: "631"
    },
    {
        label: "Paducah-Cape Girard-Harsbg",
        value: "632"
    },
    {
        label: "Odessa-Midland",
        value: "633"
    },
    {
        label: "Amarillo",
        value: "634"
    },
    {
        label: "Austin",
        value: "635"
    },
    {
        label: "Harlingen-Wslco-Brnsvl-McA",
        value: "636"
    },
    {
        label: "Cedar Rapids-Wtrlo-IWC&Dub",
        value: "637"
    },
    {
        label: "St. Joseph",
        value: "638"
    },
    {
        label: "Jackson, TN",
        value: "639"
    },
    {
        label: "Memphis",
        value: "640"
    },
    {
        label: "San Antonio",
        value: "641"
    },
    {
        label: "Lafayette, LA",
        value: "642"
    },
    {
        label: "Lake Charles",
        value: "643"
    },
    {
        label: "Alexandria, LA",
        value: "644"
    },
    {
        label: "Greenwood-Greenville",
        value: "647"
    },
    {
        label: "Champaign&Sprngfld-Decatur",
        value: "648"
    },
    {
        label: "Evansville",
        value: "649"
    },
    {
        label: "Oklahoma City",
        value: "650"
    },
    {
        label: "Lubbock",
        value: "651"
    },
    {
        label: "Omaha",
        value: "652"
    },
    {
        label: "Panama City",
        value: "656"
    },
    {
        label: "Sherman-Ada",
        value: "657"
    },
    {
        label: "Green Bay-Appleton",
        value: "658"
    },
    {
        label: "Nashville",
        value: "659"
    },
    {
        label: "San Angelo",
        value: "661"
    },
    {
        label: "Abilene-Sweetwater",
        value: "662"
    },
    {
        label: "Madison",
        value: "669"
    },
    {
        label: "Ft. Smith-Fay-Sprngdl-Rgrs",
        value: "670"
    },
    {
        label: "Tulsa",
        value: "671"
    },
    {
        label: "Columbus-Tupelo-W Pnt-Hstn",
        value: "673"
    },
    {
        label: "Peoria-Bloomington",
        value: "675"
    },
    {
        label: "Duluth-Superior",
        value: "676"
    },
    {
        label: "Wichita-Hutchinson Plus",
        value: "678"
    },
    {
        label: "Des Moines-Ames",
        value: "679"
    },
    {
        label: "Davenport-R.Island-Moline",
        value: "682"
    },
    {
        label: "Mobile-Pensacola (Ft Walt)",
        value: "686"
    },
    {
        label: "Minot-Bsmrck-Dcknsn(Wlstn)",
        value: "687"
    },
    {
        label: "Huntsville-Decatur (Flor)",
        value: "691"
    },
    {
        label: "Beaumont-Port Arthur",
        value: "692"
    },
    {
        label: "Little Rock-Pine Bluff",
        value: "693"
    },
    {
        label: "Montgomery-Selma",
        value: "698"
    },
    {
        label: "La Crosse-Eau Claire",
        value: "702"
    },
    {
        label: "Wausau-Rhinelander",
        value: "705"
    },
    {
        label: "Tyler-Longview(Lfkn&Ncgd)",
        value: "709"
    },
    {
        label: "Hattiesburg-Laurel",
        value: "710"
    },
    {
        label: "Meridian",
        value: "711"
    },
    {
        label: "Baton Rouge",
        value: "716"
    },
    {
        label: "Quincy-Hannibal-Keokuk",
        value: "717"
    },
    {
        label: "Jackson, MS",
        value: "718"
    },
    {
        label: "Lincoln & Hastings-Krny",
        value: "722"
    },
    {
        label: "Fargo-Valley City",
        value: "724"
    },
    {
        label: "Sioux Falls(Mitchell)",
        value: "725"
    },
    {
        label: "Jonesboro",
        value: "734"
    },
    {
        label: "Bowling Green",
        value: "736"
    },
    {
        label: "Mankato",
        value: "737"
    },
    {
        label: "North Platte",
        value: "740"
    },
    {
        label: "Anchorage",
        value: "743"
    },
    {
        label: "Honolulu",
        value: "744"
    },
    {
        label: "Fairbanks",
        value: "745"
    },
    {
        label: "Biloxi-Gulfport",
        value: "746"
    },
    {
        label: "Juneau",
        value: "747"
    },
    {
        label: "Laredo",
        value: "749"
    },
    {
        label: "Denver",
        value: "751"
    },
    {
        label: "Colorado Springs-Pueblo",
        value: "752"
    },
    {
        label: "Phoenix (Prescott)",
        value: "753"
    },
    {
        label: "Butte-Bozeman",
        value: "754"
    },
    {
        label: "Great Falls",
        value: "755"
    },
    {
        label: "Billings",
        value: "756"
    },
    {
        label: "Boise",
        value: "757"
    },
    {
        label: "Idaho Fals-Pocatllo(Jcksn)",
        value: "758"
    },
    {
        label: "Cheyenne-Scottsbluff",
        value: "759"
    },
    {
        label: "Twin Falls",
        value: "760"
    },
    {
        label: "Missoula",
        value: "762"
    },
    {
        label: "Rapid City",
        value: "764"
    },
    {
        label: "El Paso (Las Cruces)",
        value: "765"
    },
    {
        label: "Helena",
        value: "766"
    },
    {
        label: "Casper-Riverton",
        value: "767"
    },
    {
        label: "Salt Lake City",
        value: "770"
    },
    {
        label: "Yuma-El Centro",
        value: "771"
    },
    {
        label: "Grand Junction-Montrose",
        value: "773"
    },
    {
        label: "Tucson (Sierra Vista)",
        value: "789"
    },
    {
        label: "Albuquerque-Santa Fe",
        value: "790"
    },
    {
        label: "Glendive",
        value: "798"
    },
    {
        label: "Bakersfield",
        value: "800"
    },
    {
        label: "Eugene",
        value: "801"
    },
    {
        label: "Eureka",
        value: "802"
    },
    {
        label: "Los Angeles",
        value: "803"
    },
    {
        label: "Palm Springs",
        value: "804"
    },
    {
        label: "San Francisco-Oak-San Jose",
        value: "807"
    },
    {
        label: "Yakima-Pasco-Rchlnd-Knnwck",
        value: "810"
    },
    {
        label: "Reno",
        value: "811"
    },
    {
        label: "Medford-Klamath Falls",
        value: "813"
    },
    {
        label: "Seattle-Tacoma",
        value: "819"
    },
    {
        label: "Portland, OR",
        value: "820"
    },
    {
        label: "Bend, OR",
        value: "821"
    },
    {
        label: "San Diego",
        value: "825"
    },
    {
        label: "Monterey-Salinas",
        value: "828"
    },
    {
        label: "Las Vegas",
        value: "839"
    },
    {
        label: "SantaBarbra-SanMar-SanLuOb",
        value: "855"
    },
    {
        label: "Sacramnto-Stkton-Modesto",
        value: "862"
    },
    {
        label: "Fresno-Visalia",
        value: "866"
    },
    {
        label: "Chico-Redding",
        value: "868"
    },
    {
        label: "Spokane",
        value: "881"
    }
]
export const languages = [
    {
        value: "ab",
        label: "Abkhaz"
    },
    {
        value: "aa",
        label: "Afar"
    },
    {
        value: "af",
        label: "Afrikaans"
    },
    {
        value: "ak",
        label: "Akan"
    },
    {
        value: "sq",
        label: "Albanian"
    },
    {
        value: "am",
        label: "Amharic"
    },
    {
        value: "ar",
        label: "Arabic"
    },
    {
        value: "an",
        label: "Aragonese"
    },
    {
        value: "hy",
        label: "Armenian"
    },
    {
        value: "as",
        label: "Assamese"
    },
    {
        value: "av",
        label: "Avaric"
    },
    {
        value: "ae",
        label: "Avestan"
    },
    {
        value: "ay",
        label: "Aymara"
    },
    {
        value: "az",
        label: "Azerbaijani"
    },
    {
        value: "bm",
        label: "Bambara"
    },
    {
        value: "ba",
        label: "Bashkir"
    },
    {
        value: "eu",
        label: "Basque"
    },
    {
        value: "be",
        label: "Belarusian"
    },
    {
        value: "bn",
        label: "Bengali"
    },
    {
        value: "bh",
        label: "Bihari"
    },
    {
        value: "bi",
        label: "Bislama"
    },
    {
        value: "bs",
        label: "Bosnian"
    },
    {
        value: "br",
        label: "Breton"
    },
    {
        value: "bg",
        label: "Bulgarian"
    },
    {
        value: "my",
        label: "Burmese"
    },
    {
        value: "ca",
        label: "Catalan, Valencian"
    },
    {
        value: "ch",
        label: "Chamorro"
    },
    {
        value: "ce",
        label: "Chechen"
    },
    {
        value: "ny",
        label: "Chichewa, Chewa, Nyanja"
    },
    {
        value: "zh",
        label: "Chinese"
    },
    {
        value: "cv",
        label: "Chuvash"
    },
    {
        value: "kw",
        label: "Cornish"
    },
    {
        value: "co",
        label: "Corsican"
    },
    {
        value: "cr",
        label: "Cree"
    },
    {
        value: "hr",
        label: "Croatian"
    },
    {
        value: "cs",
        label: "Czech"
    },
    {
        value: "da",
        label: "Danish"
    },
    {
        value: "dv",
        label: "Divehi, Dhivehi, Maldivian;"
    },
    {
        value: "nl",
        label: "Dutch"
    },
    {
        value: "en",
        label: "English"
    },
    {
        value: "eo",
        label: "Esperanto"
    },
    {
        value: "et",
        label: "Estonian"
    },
    {
        value: "ee",
        label: "Ewe"
    },
    {
        value: "fo",
        label: "Faroese"
    },
    {
        value: "fj",
        label: "Fijian"
    },
    {
        value: "fi",
        label: "Finnish"
    },
    {
        value: "fr",
        label: "French"
    },
    {
        value: "ff",
        label: "Fula, Fulah, Pulaar, Pular"
    },
    {
        value: "gl",
        label: "Galician"
    },
    {
        value: "ka",
        label: "Georgian"
    },
    {
        value: "de",
        label: "German"
    },
    {
        value: "el",
        label: "Greek, Modern"
    },
    {
        value: "gn",
        label: "Guaraní"
    },
    {
        value: "gu",
        label: "Gujarati"
    },
    {
        value: "ht",
        label: "Haitian, Haitian Creole"
    },
    {
        value: "ha",
        label: "Hausa"
    },
    {
        value: "he",
        label: "Hebrew (modern)"
    },
    {
        value: "hz",
        label: "Herero"
    },
    {
        value: "hi",
        label: "Hindi"
    },
    {
        value: "ho",
        label: "Hiri Motu"
    },
    {
        value: "hu",
        label: "Hungarian"
    },
    {
        value: "ia",
        label: "Interlingua"
    },
    {
        value: "id",
        label: "Indonesian"
    },
    {
        value: "ie",
        label: "Interlingue"
    },
    {
        value: "ga",
        label: "Irish"
    },
    {
        value: "ig",
        label: "Igbo"
    },
    {
        value: "ik",
        label: "Inupiaq"
    },
    {
        value: "io",
        label: "Ido"
    },
    {
        value: "is",
        label: "Icelandic"
    },
    {
        value: "it",
        label: "Italian"
    },
    {
        value: "iu",
        label: "Inuktitut"
    },
    {
        value: "ja",
        label: "Japanese"
    },
    {
        value: "jv",
        label: "Javanese"
    },
    {
        value: "kl",
        label: "Kalaallisut, Greenlandic"
    },
    {
        value: "kn",
        label: "Kannada"
    },
    {
        value: "kr",
        label: "Kanuri"
    },
    {
        value: "ks",
        label: "Kashmiri"
    },
    {
        value: "kk",
        label: "Kazakh"
    },
    {
        value: "km",
        label: "Khmer"
    },
    {
        value: "ki",
        label: "Kikuyu, Gikuyu"
    },
    {
        value: "rw",
        label: "Kinyarwanda"
    },
    {
        value: "ky",
        label: "Kirghiz, Kyrgyz"
    },
    {
        value: "kv",
        label: "Komi"
    },
    {
        value: "kg",
        label: "Kongo"
    },
    {
        value: "ko",
        label: "Korean"
    },
    {
        value: "ku",
        label: "Kurdish"
    },
    {
        value: "kj",
        label: "Kwanyama, Kuanyama"
    },
    {
        value: "la",
        label: "Latin"
    },
    {
        value: "lb",
        label: "Luxembourgish, Letzeburgesch"
    },
    {
        value: "lg",
        label: "Luganda"
    },
    {
        value: "li",
        label: "Limburgish, Limburgan, Limburger"
    },
    {
        value: "ln",
        label: "Lingala"
    },
    {
        value: "lo",
        label: "Lao"
    },
    {
        value: "lt",
        label: "Lithuanian"
    },
    {
        value: "lu",
        label: "Luba-Katanga"
    },
    {
        value: "lv",
        label: "Latvian"
    },
    {
        value: "gv",
        label: "Manx"
    },
    {
        value: "mk",
        label: "Macedonian"
    },
    {
        value: "mg",
        label: "Malagasy"
    },
    {
        value: "ms",
        label: "Malay"
    },
    {
        value: "ml",
        label: "Malayalam"
    },
    {
        value: "mt",
        label: "Maltese"
    },
    {
        value: "mi",
        label: "Māori"
    },
    {
        value: "mr",
        label: "Marathi (Marāṭhī)"
    },
    {
        value: "mh",
        label: "Marshallese"
    },
    {
        value: "mn",
        label: "Mongolian"
    },
    {
        value: "na",
        label: "Nauru"
    },
    {
        value: "nv",
        label: "Navajo, Navaho"
    },
    {
        value: "nb",
        label: "Norwegian Bokmål"
    },
    {
        value: "nd",
        label: "North Ndebele"
    },
    {
        value: "ne",
        label: "Nepali"
    },
    {
        value: "ng",
        label: "Ndonga"
    },
    {
        value: "nn",
        label: "Norwegian Nynorsk"
    },
    {
        value: "no",
        label: "Norwegian"
    },
    {
        value: "ii",
        label: "Nuosu"
    },
    {
        value: "nr",
        label: "South Ndebele"
    },
    {
        value: "oc",
        label: "Occitan"
    },
    {
        value: "oj",
        label: "Ojibwe, Ojibwa"
    },
    {
        value: "cu",
        label: "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic"
    },
    {
        value: "om",
        label: "Oromo"
    },
    {
        value: "or",
        label: "Oriya"
    },
    {
        value: "os",
        label: "Ossetian, Ossetic"
    },
    {
        value: "pa",
        label: "Panjabi, Punjabi"
    },
    {
        value: "pi",
        label: "Pāli"
    },
    {
        value: "fa",
        label: "Persian"
    },
    {
        value: "pl",
        label: "Polish"
    },
    {
        value: "ps",
        label: "Pashto, Pushto"
    },
    {
        value: "pt",
        label: "Portuguese"
    },
    {
        value: "qu",
        label: "Quechua"
    },
    {
        value: "rm",
        label: "Romansh"
    },
    {
        value: "rn",
        label: "Kirundi"
    },
    {
        value: "ro",
        label: "Romanian, Moldavian, Moldovan"
    },
    {
        value: "ru",
        label: "Russian"
    },
    {
        value: "sa",
        label: "Sanskrit (Saṁskṛta)"
    },
    {
        value: "sc",
        label: "Sardinian"
    },
    {
        value: "sd",
        label: "Sindhi"
    },
    {
        value: "se",
        label: "Northern Sami"
    },
    {
        value: "sm",
        label: "Samoan"
    },
    {
        value: "sg",
        label: "Sango"
    },
    {
        value: "sr",
        label: "Serbian"
    },
    {
        value: "gd",
        label: "Scottish Gaelic, Gaelic"
    },
    {
        value: "sn",
        label: "Shona"
    },
    {
        value: "si",
        label: "Sinhala, Sinhalese"
    },
    {
        value: "sk",
        label: "Slovak"
    },
    {
        value: "sl",
        label: "Slovene"
    },
    {
        value: "so",
        label: "Somali"
    },
    {
        value: "st",
        label: "Southern Sotho"
    },
    {
        value: "es",
        label: "Spanish, Castilian"
    },
    {
        value: "su",
        label: "Sundanese"
    },
    {
        value: "sw",
        label: "Swahili"
    },
    {
        value: "ss",
        label: "Swati"
    },
    {
        value: "sv",
        label: "Swedish"
    },
    {
        value: "ta",
        label: "Tamil"
    },
    {
        value: "te",
        label: "Telugu"
    },
    {
        value: "tg",
        label: "Tajik"
    },
    {
        value: "th",
        label: "Thai"
    },
    {
        value: "ti",
        label: "Tigrinya"
    },
    {
        value: "bo",
        label: "Tibetan Standard, Tibetan, Central"
    },
    {
        value: "tk",
        label: "Turkmen"
    },
    {
        value: "tl",
        label: "Tagalog"
    },
    {
        value: "tn",
        label: "Tswana"
    },
    {
        value: "to",
        label: "Tonga (Tonga Islands)"
    },
    {
        value: "tr",
        label: "Turkish"
    },
    {
        value: "ts",
        label: "Tsonga"
    },
    {
        value: "tt",
        label: "Tatar"
    },
    {
        value: "tw",
        label: "Twi"
    },
    {
        value: "ty",
        label: "Tahitian"
    },
    {
        value: "ug",
        label: "Uighur, Uyghur"
    },
    {
        value: "uk",
        label: "Ukrainian"
    },
    {
        value: "ur",
        label: "Urdu"
    },
    {
        value: "uz",
        label: "Uzbek"
    },
    {
        value: "ve",
        label: "Venda"
    },
    {
        value: "vi",
        label: "Vietnamese"
    },
    {
        value: "vo",
        label: "Volapük"
    },
    {
        value: "wa",
        label: "Walloon"
    },
    {
        value: "cy",
        label: "Welsh"
    },
    {
        value: "wo",
        label: "Wolof"
    },
    {
        value: "fy",
        label: "Western Frisian"
    },
    {
        value: "xh",
        label: "Xhosa"
    },
    {
        value: "yi",
        label: "Yiddish"
    },
    {
        value: "yo",
        label: "Yoruba"
    },
    {
        value: "za",
        label: "Zhuang, Chuang"
    }
]

export const states = [
    {
        label: "Alabama",
        value: "AL"
    },
    {
        label: "Alaska",
        value: "AK"
    },
    {
        label: "American Samoa",
        value: "AS"
    },
    {
        label: "Arizona",
        value: "AZ"
    },
    {
        label: "Arkansas",
        value: "AR"
    },
    {
        label: "California",
        value: "CA"
    },
    {
        label: "Colorado",
        value: "CO"
    },
    {
        label: "Connecticut",
        value: "CT"
    },
    {
        label: "Delaware",
        value: "DE"
    },
    {
        label: "District Of Columbia",
        value: "DC"
    },
    {
        label: "Federated States Of Micronesia",
        value: "FM"
    },
    {
        label: "Florida",
        value: "FL"
    },
    {
        label: "Georgia",
        value: "GA"
    },
    {
        label: "Guam",
        value: "GU"
    },
    {
        label: "Hawaii",
        value: "HI"
    },
    {
        label: "Idaho",
        value: "ID"
    },
    {
        label: "Illinois",
        value: "IL"
    },
    {
        label: "Indiana",
        value: "IN"
    },
    {
        label: "Iowa",
        value: "IA"
    },
    {
        label: "Kansas",
        value: "KS"
    },
    {
        label: "Kentucky",
        value: "KY"
    },
    {
        label: "Louisiana",
        value: "LA"
    },
    {
        label: "Maine",
        value: "ME"
    },
    {
        label: "Marshall Islands",
        value: "MH"
    },
    {
        label: "Maryland",
        value: "MD"
    },
    {
        label: "Massachusetts",
        value: "MA"
    },
    {
        label: "Michigan",
        value: "MI"
    },
    {
        label: "Minnesota",
        value: "MN"
    },
    {
        label: "Mississippi",
        value: "MS"
    },
    {
        label: "Missouri",
        value: "MO"
    },
    {
        label: "Montana",
        value: "MT"
    },
    {
        label: "Nebraska",
        value: "NE"
    },
    {
        label: "Nevada",
        value: "NV"
    },
    {
        label: "New Hampshire",
        value: "NH"
    },
    {
        label: "New Jersey",
        value: "NJ"
    },
    {
        label: "New Mexico",
        value: "NM"
    },
    {
        label: "New York",
        value: "NY"
    },
    {
        label: "North Carolina",
        value: "NC"
    },
    {
        label: "North Dakota",
        value: "ND"
    },
    {
        label: "Northern Mariana Islands",
        value: "MP"
    },
    {
        label: "Ohio",
        value: "OH"
    },
    {
        label: "Oklahoma",
        value: "OK"
    },
    {
        label: "Oregon",
        value: "OR"
    },
    {
        label: "Palau",
        value: "PW"
    },
    {
        label: "Pennsylvania",
        value: "PA"
    },
    {
        label: "Puerto Rico",
        value: "PR"
    },
    {
        label: "Rhode Island",
        value: "RI"
    },
    {
        label: "South Carolina",
        value: "SC"
    },
    {
        label: "South Dakota",
        value: "SD"
    },
    {
        label: "Tennessee",
        value: "TN"
    },
    {
        label: "Texas",
        value: "TX"
    },
    {
        label: "Utah",
        value: "UT"
    },
    {
        label: "Vermont",
        value: "VT"
    },
    {
        label: "Virgin Islands",
        value: "VI"
    },
    {
        label: "Virginia",
        value: "VA"
    },
    {
        label: "Washington",
        value: "WA"
    },
    {
        label: "West Virginia",
        value: "WV"
    },
    {
        label: "Wisconsin",
        value: "WI"
    },
    {
        label: "Wyoming",
        value: "WY"
    }
]
export const regions = [
    {
        "country": "Afghanistan",
        value: "Southern and Central Asia",
        label: "Southern and Central Asia"
    },
    {
        "country": "Albania",
        value: "Southern Europe",
        label: "Southern Europe"
    },
    {
        "country": "Algeria",
        value: "Northern Africa",
        label: "Northern Africa"
    },
    {
        "country": "American Samoa",
        value: "Polynesia",
        label: "Polynesia"
    },
    {
        "country": "Andorra",
        value: "Southern Europe",
        label: "Southern Europe"
    },
    {
        "country": "Angola",
        value: "Central Africa",
        label: "Central Africa"
    },
    {
        "country": "Anguilla",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Antarctica",
        value: "Antarctica",
        label: "Antarctica"
    },
    {
        "country": "Antigua and Barbuda",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Argentina",
        value: "South America",
        label: "South America"
    },
    {
        "country": "Armenia",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Aruba",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Australia",
        value: "Australia and New Zealand",
        label: "Australia and New Zealand"
    },
    {
        "country": "Austria",
        value: "Western Europe",
        label: "Western Europe"
    },
    {
        "country": "Azerbaijan",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Bahamas",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Bahrain",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Bangladesh",
        value: "Southern and Central Asia",
        label: "Southern and Central Asia"
    },
    {
        "country": "Barbados",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Belarus",
        value: "Eastern Europe",
        label: "Eastern Europe"
    },
    {
        "country": "Belgium",
        value: "Western Europe",
        label: "Western Europe"
    },
    {
        "country": "Belize",
        value: "Central America",
        label: "Central America"
    },
    {
        "country": "Benin",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Bermuda",
        value: "North America",
        label: "North America"
    },
    {
        "country": "Bhutan",
        value: "Southern and Central Asia",
        label: "Southern and Central Asia"
    },
    {
        "country": "Bolivia",
        value: "South America",
        label: "South America"
    },
    {
        "country": "Bosnia and Herzegovina",
        value: "Southern Europe",
        label: "Southern Europe"
    },
    {
        "country": "Botswana",
        value: "Southern Africa",
        label: "Southern Africa"
    },
    {
        "country": "Bouvet Island",
        value: "Antarctica",
        label: "Antarctica"
    },
    {
        "country": "Brazil",
        value: "South America",
        label: "South America"
    },
    {
        "country": "British Indian Ocean Territory",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Brunei",
        value: "Southeast Asia",
        label: "Southeast Asia"
    },
    {
        "country": "Bulgaria",
        value: "Eastern Europe",
        label: "Eastern Europe"
    },
    {
        "country": "Burkina Faso",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Burundi",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Cambodia",
        value: "Southeast Asia",
        label: "Southeast Asia"
    },
    {
        "country": "Cameroon",
        value: "Central Africa",
        label: "Central Africa"
    },
    {
        "country": "Canada",
        value: "North America",
        label: "North America"
    },
    {
        "country": "Cape Verde",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Cayman Islands",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Central African Republic",
        value: "Central Africa",
        label: "Central Africa"
    },
    {
        "country": "Chad",
        value: "Central Africa",
        label: "Central Africa"
    },
    {
        "country": "Chile",
        value: "South America",
        label: "South America"
    },
    {
        "country": "China",
        value: "Eastern Asia",
        label: "Eastern Asia"
    },
    {
        "country": "Christmas Island",
        value: "Australia and New Zealand",
        label: "Australia and New Zealand"
    },
    {
        "country": "Cocos (Keeling) Islands",
        value: "Australia and New Zealand",
        label: "Australia and New Zealand"
    },
    {
        "country": "Colombia",
        value: "South America",
        label: "South America"
    },
    {
        "country": "Comoros",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Congo",
        value: "Central Africa",
        label: "Central Africa"
    },
    {
        "country": "Cook Islands",
        value: "Polynesia",
        label: "Polynesia"
    },
    {
        "country": "Costa Rica",
        value: "Central America",
        label: "Central America"
    },
    {
        "country": "Croatia",
        value: "Southern Europe",
        label: "Southern Europe"
    },
    {
        "country": "Cuba",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Cyprus",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Czech Republic",
        value: "Eastern Europe",
        label: "Eastern Europe"
    },
    {
        "country": "Denmark",
        value: "Nordic Countries",
        label: "Nordic Countries"
    },
    {
        "country": "Djibouti",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Dominica",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Dominican Republic",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "East Timor",
        value: "Southeast Asia",
        label: "Southeast Asia"
    },
    {
        "country": "Ecuador",
        value: "South America",
        label: "South America"
    },
    {
        "country": "Egypt",
        value: "Northern Africa",
        label: "Northern Africa"
    },
    {
        "country": "El Salvador",
        value: "Central America",
        label: "Central America"
    },
    {
        "country": "England",
        value: null,
        label: null
    },
    {
        "country": "Equatorial Guinea",
        value: "Central Africa",
        label: "Central Africa"
    },
    {
        "country": "Eritrea",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Estonia",
        value: "Baltic Countries",
        label: "Baltic Countries"
    },
    {
        "country": "Ethiopia",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Falkland Islands",
        value: "South America",
        label: "South America"
    },
    {
        "country": "Faroe Islands",
        value: "Nordic Countries",
        label: "Nordic Countries"
    },
    {
        "country": "Fiji Islands",
        value: "Melanesia",
        label: "Melanesia"
    },
    {
        "country": "Finland",
        value: "Nordic Countries",
        label: "Nordic Countries"
    },
    {
        "country": "France",
        value: "Western Europe",
        label: "Western Europe"
    },
    {
        "country": "French Guiana",
        value: "South America",
        label: "South America"
    },
    {
        "country": "French Polynesia",
        value: "Polynesia",
        label: "Polynesia"
    },
    {
        "country": "French Southern territories",
        value: "Antarctica",
        label: "Antarctica"
    },
    {
        "country": "Gabon",
        value: "Central Africa",
        label: "Central Africa"
    },
    {
        "country": "Gambia",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Georgia",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Germany",
        value: "Western Europe",
        label: "Western Europe"
    },
    {
        "country": "Ghana",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Gibraltar",
        value: "Southern Europe",
        label: "Southern Europe"
    },
    {
        "country": "Greece",
        value: "Southern Europe",
        label: "Southern Europe"
    },
    {
        "country": "Greenland",
        value: "North America",
        label: "North America"
    },
    {
        "country": "Grenada",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Guadeloupe",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Guam",
        value: "Micronesia",
        label: "Micronesia"
    },
    {
        "country": "Guatemala",
        value: "Central America",
        label: "Central America"
    },
    {
        "country": "Guinea",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Guinea-Bissau",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Guyana",
        value: "South America",
        label: "South America"
    },
    {
        "country": "Haiti",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Heard Island and McDonald Islands",
        value: "Antarctica",
        label: "Antarctica"
    },
    {
        "country": "Holy See (Vatican City State)",
        value: "Southern Europe",
        label: "Southern Europe"
    },
    {
        "country": "Honduras",
        value: "Central America",
        label: "Central America"
    },
    {
        "country": "Hong Kong",
        value: "Eastern Asia",
        label: "Eastern Asia"
    },
    {
        "country": "Hungary",
        value: "Eastern Europe",
        label: "Eastern Europe"
    },
    {
        "country": "Iceland",
        value: "Nordic Countries",
        label: "Nordic Countries"
    },
    {
        "country": "India",
        value: "Southern and Central Asia",
        label: "Southern and Central Asia"
    },
    {
        "country": "Indonesia",
        value: "Southeast Asia",
        label: "Southeast Asia"
    },
    {
        "country": "Iran",
        value: "Southern and Central Asia",
        label: "Southern and Central Asia"
    },
    {
        "country": "Iraq",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Ireland",
        value: "British Isles",
        label: "British Isles"
    },
    {
        "country": "Israel",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Italy",
        value: "Southern Europe",
        label: "Southern Europe"
    },
    {
        "country": "Ivory Coast",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Jamaica",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Japan",
        value: "Eastern Asia",
        label: "Eastern Asia"
    },
    {
        "country": "Jordan",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Kazakhstan",
        value: "Southern and Central Asia",
        label: "Southern and Central Asia"
    },
    {
        "country": "Kenya",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Kiribati",
        value: "Micronesia",
        label: "Micronesia"
    },
    {
        "country": "Kuwait",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Kyrgyzstan",
        value: "Southern and Central Asia",
        label: "Southern and Central Asia"
    },
    {
        "country": "Laos",
        value: "Southeast Asia",
        label: "Southeast Asia"
    },
    {
        "country": "Latvia",
        value: "Baltic Countries",
        label: "Baltic Countries"
    },
    {
        "country": "Lebanon",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Lesotho",
        value: "Southern Africa",
        label: "Southern Africa"
    },
    {
        "country": "Liberia",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Libyan Arab Jamahiriya",
        value: "Northern Africa",
        label: "Northern Africa"
    },
    {
        "country": "Liechtenstein",
        value: "Western Europe",
        label: "Western Europe"
    },
    {
        "country": "Lithuania",
        value: "Baltic Countries",
        label: "Baltic Countries"
    },
    {
        "country": "Luxembourg",
        value: "Western Europe",
        label: "Western Europe"
    },
    {
        "country": "Macao",
        value: "Eastern Asia",
        label: "Eastern Asia"
    },
    {
        "country": "North Macedonia",
        value: "Southern Europe",
        label: "Southern Europe"
    },
    {
        "country": "Madagascar",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Malawi",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Malaysia",
        value: "Southeast Asia",
        label: "Southeast Asia"
    },
    {
        "country": "Maldives",
        value: "Southern and Central Asia",
        label: "Southern and Central Asia"
    },
    {
        "country": "Mali",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Malta",
        value: "Southern Europe",
        label: "Southern Europe"
    },
    {
        "country": "Marshall Islands",
        value: "Micronesia",
        label: "Micronesia"
    },
    {
        "country": "Martinique",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Mauritania",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Mauritius",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Mayotte",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Mexico",
        value: "Central America",
        label: "Central America"
    },
    {
        "country": "Micronesia, Federated States of",
        value: "Micronesia",
        label: "Micronesia"
    },
    {
        "country": "Moldova",
        value: "Eastern Europe",
        label: "Eastern Europe"
    },
    {
        "country": "Monaco",
        value: "Western Europe",
        label: "Western Europe"
    },
    {
        "country": "Mongolia",
        value: "Eastern Asia",
        label: "Eastern Asia"
    },
    {
        "country": "Montserrat",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Morocco",
        value: "Northern Africa",
        label: "Northern Africa"
    },
    {
        "country": "Mozambique",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Myanmar",
        value: "Southeast Asia",
        label: "Southeast Asia"
    },
    {
        "country": "Namibia",
        value: "Southern Africa",
        label: "Southern Africa"
    },
    {
        "country": "Nauru",
        value: "Micronesia",
        label: "Micronesia"
    },
    {
        "country": "Nepal",
        value: "Southern and Central Asia",
        label: "Southern and Central Asia"
    },
    {
        "country": "Netherlands",
        value: "Western Europe",
        label: "Western Europe"
    },
    {
        "country": "Netherlands Antilles",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "New Caledonia",
        value: "Melanesia",
        label: "Melanesia"
    },
    {
        "country": "New Zealand",
        value: "Australia and New Zealand",
        label: "Australia and New Zealand"
    },
    {
        "country": "Nicaragua",
        value: "Central America",
        label: "Central America"
    },
    {
        "country": "Niger",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Nigeria",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Niue",
        value: "Polynesia",
        label: "Polynesia"
    },
    {
        "country": "Norfolk Island",
        value: "Australia and New Zealand",
        label: "Australia and New Zealand"
    },
    {
        "country": "North Korea",
        value: "Eastern Asia",
        label: "Eastern Asia"
    },
    {
        "country": "Northern Ireland",
        value: null,
        label: null
    },
    {
        "country": "Northern Mariana Islands",
        value: "Micronesia",
        label: "Micronesia"
    },
    {
        "country": "Norway",
        value: "Nordic Countries",
        label: "Nordic Countries"
    },
    {
        "country": "Oman",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Pakistan",
        value: "Southern and Central Asia",
        label: "Southern and Central Asia"
    },
    {
        "country": "Palau",
        value: "Micronesia",
        label: "Micronesia"
    },
    {
        "country": "Palestine",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Panama",
        value: "Central America",
        label: "Central America"
    },
    {
        "country": "Papua New Guinea",
        value: "Melanesia",
        label: "Melanesia"
    },
    {
        "country": "Paraguay",
        value: "South America",
        label: "South America"
    },
    {
        "country": "Peru",
        value: "South America",
        label: "South America"
    },
    {
        "country": "Philippines",
        value: "Southeast Asia",
        label: "Southeast Asia"
    },
    {
        "country": "Pitcairn",
        value: "Polynesia",
        label: "Polynesia"
    },
    {
        "country": "Poland",
        value: "Eastern Europe",
        label: "Eastern Europe"
    },
    {
        "country": "Portugal",
        value: "Southern Europe",
        label: "Southern Europe"
    },
    {
        "country": "Puerto Rico",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Qatar",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Reunion",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Romania",
        value: "Eastern Europe",
        label: "Eastern Europe"
    },
    {
        "country": "Russian Federation",
        value: "Eastern Europe",
        label: "Eastern Europe"
    },
    {
        "country": "Rwanda",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Saint Helena",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Saint Kitts and Nevis",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Saint Lucia",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Saint Pierre and Miquelon",
        value: "North America",
        label: "North America"
    },
    {
        "country": "Saint Vincent and the Grenadines",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Samoa",
        value: "Polynesia",
        label: "Polynesia"
    },
    {
        "country": "San Marino",
        value: "Southern Europe",
        label: "Southern Europe"
    },
    {
        "country": "Sao Tome and Principe",
        value: "Central Africa",
        label: "Central Africa"
    },
    {
        "country": "Saudi Arabia",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Scotland",
        value: null,
        label: null
    },
    {
        "country": "Senegal",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Serbia",
        value: "Central and Southeast Europe",
        label: "Central and Southeast Europe"
    },
    {
        "country": "Seychelles",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Sierra Leone",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Singapore",
        value: "Southeast Asia",
        label: "Southeast Asia"
    },
    {
        "country": "Slovakia",
        value: "Eastern Europe",
        label: "Eastern Europe"
    },
    {
        "country": "Slovenia",
        value: "Southern Europe",
        label: "Southern Europe"
    },
    {
        "country": "Solomon Islands",
        value: "Melanesia",
        label: "Melanesia"
    },
    {
        "country": "Somalia",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "South Africa",
        value: "Southern Africa",
        label: "Southern Africa"
    },
    {
        "country": "South Georgia and the South Sandwich Islands",
        value: "Antarctica",
        label: "Antarctica"
    },
    {
        "country": "South Korea",
        value: "Eastern Asia",
        label: "Eastern Asia"
    },
    {
        "country": "South Sudan",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Spain",
        value: "Southern Europe",
        label: "Southern Europe"
    },
    {
        "country": "Sri Lanka",
        value: "Southern Asia",
        label: "Southern Asia"
    },
    {
        "country": "Sudan",
        value: "Northern Africa",
        label: "Northern Africa"
    },
    {
        "country": "Suriname",
        value: "South America",
        label: "South America"
    },
    {
        "country": "Svalbard and Jan Mayen",
        value: "Nordic Countries",
        label: "Nordic Countries"
    },
    {
        "country": "Swaziland",
        value: "Southern Africa",
        label: "Southern Africa"
    },
    {
        "country": "Sweden",
        value: "Nordic Countries",
        label: "Nordic Countries"
    },
    {
        "country": "Switzerland",
        value: "Western Europe",
        label: "Western Europe"
    },
    {
        "country": "Syria",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Tajikistan",
        value: "Southern and Central Asia",
        label: "Southern and Central Asia"
    },
    {
        "country": "Tanzania",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Thailand",
        value: "Southeast Asia",
        label: "Southeast Asia"
    },
    {
        "country": "The Democratic Republic of Congo",
        value: null,
        label: null
    },
    {
        "country": "Togo",
        value: "Western Africa",
        label: "Western Africa"
    },
    {
        "country": "Tokelau",
        value: "Polynesia",
        label: "Polynesia"
    },
    {
        "country": "Tonga",
        value: "Polynesia",
        label: "Polynesia"
    },
    {
        "country": "Trinidad and Tobago",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Tunisia",
        value: "Northern Africa",
        label: "Northern Africa"
    },
    {
        "country": "Turkey",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Turkmenistan",
        value: "Southern and Central Asia",
        label: "Southern and Central Asia"
    },
    {
        "country": "Turks and Caicos Islands",
        value: "Caribbean",
        label: "Caribbean"
    },
    {
        "country": "Tuvalu",
        value: "Polynesia",
        label: "Polynesia"
    },
    {
        "country": "Uganda",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Ukraine",
        value: "Eastern Europe",
        label: "Eastern Europe"
    },
    {
        "country": "United Arab Emirates",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "United Kingdom",
        value: "British Isles",
        label: "British Isles"
    },
    {
        "country": "United States",
        value: "North America",
        label: "North America"
    },
    {
        "country": "United States Minor Outlying Islands",
        value: "Micronesia/Caribbean",
        label: "Micronesia/Caribbean"
    },
    {
        "country": "Uruguay",
        value: "South America",
        label: "South America"
    },
    {
        "country": "Uzbekistan",
        value: "Southern and Central Asia",
        label: "Southern and Central Asia"
    },
    {
        "country": "Vanuatu",
        value: "Melanesia",
        label: "Melanesia"
    },
    {
        "country": "Venezuela",
        value: "South America",
        label: "South America"
    },
    {
        "country": "Vietnam",
        value: "Southeast Asia",
        label: "Southeast Asia"
    },
    {
        "country": "Virgin Islands, British",
        value: null,
        label: null
    },
    {
        "country": "Virgin Islands, U.S.",
        value: null,
        label: null
    },
    {
        "country": "Wales",
        value: null,
        label: null
    },
    {
        "country": "Wallis and Futuna",
        value: "Polynesia",
        label: "Polynesia"
    },
    {
        "country": "Western Sahara",
        value: "Northern Africa",
        label: "Northern Africa"
    },
    {
        "country": "Yemen",
        value: "Middle East",
        label: "Middle East"
    },
    {
        "country": "Zambia",
        value: "Eastern Africa",
        label: "Eastern Africa"
    },
    {
        "country": "Zimbabwe",
        value: "Eastern Africa",
        label: "Eastern Africa"
    }
]